export default {
  PaletteFooter: {
    backgroundColor: "white",
    height: "4vh",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    fontWeight: "bold"
  },
  emoji: {
    fontSize: "1rem",
    margin: "0 1rem"
  }
};
